import React from 'react';

const BrandMark = ({ className = '' }) => {
  return (
    <div className={`fixed bottom-6 right-6 z-50 ${className}`}>
      <img 
        src="https://customer-assets.emergentagent.com/job_doctoapp/artifacts/xbbvvrj8_Gntl%20Strngth%20-%20Brand%20MarkArtboard%201.png" 
        alt="GNTL STRNGTH" 
        className="w-12 h-12 opacity-40 hover:opacity-60 transition-opacity"
      />
    </div>
  );
};

export default BrandMark;
